import formatMoney from '../../core/formatMoney';

export default (product) => {
  const CONSTANTS = {
    MONEY_FORMAT: theme.moneyFormat,
    DEFAULT_ALT_TEXT: {
      FRONT: 'Front of',
      BACK: 'Back of',
      WITH_COLOR: 'with color',
    }
  };

  // Determine price display
  let priceHtml = '';
  let product_from = '';
  if (product.raw_price_max > product.raw_price_min) {
    product_from = product.price_min;
  }

  if (product_from === '') {
    if (product.raw_compare_at_price > product.raw_price) {
      priceHtml = `
        <span class="visually-hidden">Regular price</span>
        <s class="price__compare-at">${formatMoney(Number(product.compare_at_price).toFixed(2), CONSTANTS.MONEY_FORMAT)}</s>
        <span class="price__sales">${formatMoney(Number(product.price).toFixed(2), CONSTANTS.MONEY_FORMAT)}</span>
      `;
    } else {
      priceHtml = `<span class="price__regular">${formatMoney(Number(product.price).toFixed(2), CONSTANTS.MONEY_FORMAT)}</span>`;
    }
  } else {
    priceHtml = `<span class="price__regular">From ${formatMoney(Number(product_from).toFixed(2), CONSTANTS.MONEY_FORMAT)}</span>`;
  }

  // const is_loyalty_member = (typeof window.theme.customer.id !== 'undefined');
  // console.log('product', product);
  // const wishlist = (is_loyalty_member) ?
  //   `<button type="button" class="no-themed add-to-wishlist-view-product product_${product.product_id}" data-product-wishlist data-product-id="${product.product_id}" data-variant-id="${product.skus[0].id}" data-product-url="${product.url}" data-product-handle="${product_handle}" data-is-init="false" aria-label="${window.theme.strings.addToWishlist}"></button>` :
  //   `<button type="button" class="no-themed add-to-wishlist-view-product product_${product.product_id}" data-product-wishlist data-product-handle="${product_handle}" data-open-signin-actions-modal="wishlist" aria-label="${window.theme.strings.addToWishlist}"></button>`;

  return `
    <div class="recently-viewed-products-item swiper-slide">
      <a href="${window.Shopify.routes.root}products/${product.handle}">
        <div class="recently-viewed-products__image">
          <img loading="lazy" alt="${product.title}" src="${product.featured_image.replace('.jpg', '_220x340@2x.jpg')}" onError="this.onerror=null; this.src='${window.theme.collections.placeholder}';" />
          <div class="recently-viewed-products__shop">SHOP NOW</div>
        </div>
        <p class="recently-viewed-products__name">${product.title}</p>
        <p class="recently-viewed-products__price">${priceHtml}</p>
      </a>
    </div>
  `;
};
